import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function LastChangeLinkIcon({
  width = 50,
  height = 50,
  fill = 'none',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} fill={fill} {...props}>
      <g fill="#748AA1">
        <path d="M1.996 3.696c0-.24.194-.434.434-.434h5.376a.434.434 0 010 .868H2.43a.434.434 0 01-.434-.434zM1.996 6.611c0-.24.194-.434.434-.434h4.032a.434.434 0 010 .868H2.43a.434.434 0 01-.434-.434zM2.436 9.08a.434.434 0 000 .868h2.71a.434.434 0 100-.868h-2.71zM9.62 8.14a2.328 2.328 0 01.851 0 .217.217 0 01-.079.426 1.894 1.894 0 00-.692 0 .217.217 0 01-.08-.427zM8.022 9.817a.217.217 0 01.174.253 1.892 1.892 0 000 .692.217.217 0 01-.427.08 2.327 2.327 0 010-.852.217.217 0 01.253-.173zM12.323 9.99a.217.217 0 10-.427.08 1.886 1.886 0 010 .692.217.217 0 00.427.08 2.324 2.324 0 000-.852zM9.447 12.44a.217.217 0 01.253-.174 1.896 1.896 0 00.692 0 .217.217 0 11.08.427 2.325 2.325 0 01-.852 0 .217.217 0 01-.173-.253zM10.047 11.977a.217.217 0 01-.217-.217v-1.434l1.408-1.407a.217.217 0 11.306.306l-1.28 1.28v1.255c0 .12-.097.217-.217.217z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.83.447a.217.217 0 00-.216-.217H8.877a.217.217 0 00-.185.33H1.535C.793.56.191 1.162.191 1.904v9.856c0 .742.602 1.344 1.344 1.344h6.141a3.584 3.584 0 102.819-6.244V3.923h.001L7.136.561h1.556c.009.013.02.027.032.04l1.736 1.734c.137.137.37.04.37-.153V.447zm-9.295 1.01h5.24l2.824 2.811V6.86a3.585 3.585 0 00-2.657 5.348H1.535a.448.448 0 01-.448-.448V1.904c0-.247.201-.448.448-.448zm8.512 11.675a2.716 2.716 0 100-5.432 2.716 2.716 0 000 5.432z"
        />
      </g>
    </svg>
  );
}

const MemoLastChangeLinkIcon = React.memo(LastChangeLinkIcon);
export default MemoLastChangeLinkIcon;
